"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../../../hooks");
const useStyles = props => {
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const {
    pxToRem
  } = (0, _hooks.useStylesUtils)();
  const {
    type = 'basic',
    size = 'medium',
    flexValues = {}
  } = props;
  const ccCardSectionStyle = (0, _react.useMemo)(() => {
    const typeProps = () => {
      const padding = type === 'graphic' ? `${pxToRem(20)} ${pxToRem(40)}` : size === 'small' ? pxToRem(12) : size === 'large' ? pxToRem(20) : pxToRem(16);
      return {
        padding
      };
    };
    const mobileTypeProps = () => {
      if (isMobileView && type === 'graphic') {
        const padding = `${pxToRem(20)} ${pxToRem(24)}`;
        return {
          padding
        };
      }
      return {};
    };
    const ccCardSection = (0, _css.css)({
      ...typeProps(),
      ...mobileTypeProps(),
      ...flexValues,
      '& + [data-id=cardSection]': {
        paddingTop: 0
      }
    });
    return ccCardSection;
  }, [flexValues, isMobileView, pxToRem, size, type]);
  return {
    'cc-CardSection': ccCardSectionStyle
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;